import React, { ReactElement } from 'react';
import ChampMultiple, { affichageElementDefaut } from '../../Common/ChampMultiple';
import { ArrayHelpers } from 'formik';
import { useAlertDialog } from '../../../Utils/dialogContext';
import { PopoutEntite } from '../Utils/PopoutEntite';
import { Activite } from '../../../../../common/src/entities';
import PopoverSimple from '../../Common/PopoverSimple';
import { BiNote } from 'react-icons/bi';
import { CopierPressePapier } from '../Utils/CopierPressePapier';
import { cssTexte } from '../constantes';

function AffichageTexte(props: { value: Activite }): ReactElement {
    const {
        value: { notes },
    } = props;

    let notesWithBreaks: JSX.Element[] = [];
    if (notes) notesWithBreaks = notes.split('\n').map((line, index) => <div key={index}>{line}</div>);

    const notesInternesIcon = (
        <CopierPressePapier texte={notes}>
            <PopoverSimple texte={notesWithBreaks} titre="Notes">
                <BiNote />
            </PopoverSimple>
        </CopierPressePapier>
    );

    return (
        <div style={cssTexte}>
            <span>{notesInternesIcon}</span>
        </div>
    );
}

function AffichageAjoutActivite(props: {
    helpers: ArrayHelpers;
    values: Activite[];
    title?: string;
    maxSize?: number;
    avecUnBouton?: boolean;
    appendedChildren?: ReactElement;
    onChange?: (activite: Activite) => void;
}): ReactElement {
    const bsAlert = useAlertDialog();
    return (
        <PopoutEntite
            affichageOption={(a: Activite) => (
                <>
                    {a.name} (<i>{a.fournisseur?.name}</i>)
                </>
            )}
            titre={`Ajouter une ${props.title?.toLowerCase() ?? 'activite'}`}
            entite={Activite}
            isCreatable
            modalSize="lg"
            size="sm"
            disabled={props.maxSize === props.values.length ? true : false}
            onChange={(value) => {
                const activite = value as Activite;
                if (activite) {
                    if (props.values?.find((item) => item.id === activite.id)) {
                        bsAlert('Cette activité est déjà associée!', 'warning');
                    } else if (props.maxSize && props.values.length === props.maxSize) {
                        bsAlert(`Vous ne pouvez qu'ajouter un max de ${props.maxSize} élément(s)`, 'warning');
                    } else {
                        props.helpers.unshift(value);
                    }
                }
                if (props.onChange) props.onChange(activite);
            }}
            avecUnBouton={props.avecUnBouton}
        />
    );
}

function affichageActivite(a: Activite) {
    return (
        <>
            <div style={cssTexte}>
                <>
                    {a.name} (<i>{a.fournisseur?.name}</i>)
                </>
            </div>
            <div>
                <AffichageTexte value={a} />
            </div>
        </>
    );
}

const affichageAjoutActivite = (
    values,
    helpers,
    maxSize?: number,
    title?: string,
    avecUnBouton?: boolean,
    appendedChildren?: ReactElement,
    onChange?: (activite: Activite) => void,
) => (
    <AffichageAjoutActivite
        helpers={helpers}
        values={values}
        maxSize={maxSize}
        title={title}
        avecUnBouton={avecUnBouton}
        appendedChildren={appendedChildren}
        onChange={onChange}
    />
);

interface PropsChampMultipleActivite {
    id: string;
    maxSize?: number;
    title?: string;
    labelCol?: number;
    estPetit?: boolean;
    avecUnBouton?: boolean;
    appendedChildren?: ReactElement;
    onChange?: (activite: Activite) => void;
}

export default function ChampMultipleActivite(props: PropsChampMultipleActivite): ReactElement {
    return (
        <ChampMultiple
            entite={Activite}
            titre={`${props.title ?? 'Activité'}`}
            {...props}
            affichageAjout={affichageAjoutActivite}
            affichageTexte={(activite: Activite | number) => affichageActivite(activite as Activite)}
            affichageElement={affichageElementDefaut(Activite)}
            onChange={props.onChange}
        />
    );
}
